import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdAdd, MdSearch } from "react-icons/md";
import OneCustomer from "../ones/OneCustomer";

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [publishedRecs, setPublishedRecs] = useState(null);
  const [unpublishedRecs, setUnpublishedRecs] = useState(null);
  const [recsList, setRecsList] = useState(null);
  const [filter, setFilter] = useState("");
  const [category, setCategory] = useState("all");

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllCustomers()]);
    setReady(true);
  }

  function categorizeRecs() {
    if (appContext.allCustomers) {
      const _published = appContext.allCustomers.filter((item) => item.status === "published");
      const _unpublished = appContext.allCustomers.filter((item) => item.status === "unpublished");
      setPublishedRecs(_published);
      setUnpublishedRecs(_unpublished);
    }
  }

  function processRecs() {
    let _list = appContext.allCustomers;

    if (category === "unpublished") {
      _list = unpublishedRecs;
    } else if (category === "published") {
      _list = publishedRecs;
    }

    if (filter && filter.trim().length > 0) {
      setRecsList(
        _list?.filter((item) => String(item.fullname).toLowerCase().indexOf(String(filter).toLowerCase()) > -1)
      );
    } else {
      setRecsList(_list);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    categorizeRecs();
  }, [appContext.allCustomers]);

  useEffect(() => {
    processRecs();
  }, [filter, category, appContext.allCustomers, publishedRecs, unpublishedRecs]);

  if (ready) {
    return (
      <div className="container">
        <div className="app-page">
          <div className="app-page-hero app-page-hero-split">
            <div>
              <p className="app-page-eyebrow">Customer management</p>
              <h6 className="main-section-title">Customers</h6>
              <p className="app-page-subtitle">
                Keep customer profiles organized for sales follow-up, payment tracking, and loan administration.
              </p>
            </div>

            <button
              className="btn btn-primary btn-rounded app-cta-btn"
              onClick={() => {
                appContext.navTo({
                  item: "view",
                  subItem: "create-customer",
                });
              }}
            >
              <MdAdd size={18} />
              Add Customer
            </button>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="summary-mini-card">
                <span>Total customers</span>
                <strong>{appContext.allCustomers?.length || 0}</strong>
              </div>
            </div>
          </div>

          <div className="list-shell">
            <div className="list-toolbar">
              <div className="modern-search">
                <MdSearch size={20} />
                <input className="form-control" onChange={(e) => setFilter(e.target.value)} placeholder="Search customers" />
              </div>

              <select className="form-control modern-filter" value={category} onChange={(e) => setCategory(e.target.value)}>
                <option value="all">All records</option>
              </select>
            </div>

            {filter && filter.trim().length > 0 ? (
              <div className="list-feedback">Results for "{filter}"</div>
            ) : (
              ""
            )}

            <div className="entity-list">
              {recsList && recsList.length > 0 ? recsList.map((item, i) => <OneCustomer key={i} data={item} />) : <div className="empty-state-lite">No customer records were found.</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
